import type {ReactElement} from 'react';
import {SocialProfileIcon} from '@Components/social-media/components/social-profile-icon';
import {useRemoveAccountFromPost} from '@Components/social-media-wizard/social-media-wizard-feature.hooks';
import type {RailAccountProfileIconProps} from './rail-account-profile-icon.types';

export function RailAccountProfileIcon({account, platformMediaType, size, canRemoveAccount, onSelect}: RailAccountProfileIconProps): ReactElement {
  const removeAccountFromPost = useRemoveAccountFromPost(account);

  return (
    <SocialProfileIcon
      account={account}
      size={size}
      platformMediaType={platformMediaType}
      showHoverOverlay={false}
      onClick={onSelect}
      onRemoveClick={canRemoveAccount ? removeAccountFromPost : undefined}
    />
  );
}
